<template>
  <div class="card" v-if="model">
    <form>
      <div class="card-header">
        <h4 class="card-title">Billing Edit Form</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="form-group col-2">
            <label>Billing ID</label>
            <fg-input readonly type="text" name="prescription_id" v-model="model.billing_id"></fg-input>
          </div>

          <div class="form-group col-2">
            <label>Location ID</label>
            <fg-input readonly type="text" name="location_id" v-model="model.location_id"></fg-input>
          </div>

          <div class="form-group col-3">
            <label>Location Name</label>
            <fg-input readonly type="text" name="location_name" v-model="model.location_name"></fg-input>
          </div>

          <div class="form-group col-2">
            <label>Patient ID</label>
            <fg-input readonly type="text" name="patient_id" v-model="model.patient_id"></fg-input>
          </div>

          <div class="form-group col-3">
            <label>Patient Name</label>
            <fg-input readonly type="text" name="patient_name" v-model="model.patient_name"></fg-input>
          </div>

          <div class="form-group col-4">
            <label>Medication Start Date</label>
            <fg-input
              name="start_date"
              type="datetime"
              v-validate="modelValidations.start_date"
              v-model="model.start_date"
              :error="getError('start_date')"
            >
              <el-date-picker
                name="start_date"
                v-model="model.start_date"
                type="date"
                placeholder="Pick a Start Date"
              ></el-date-picker>
            </fg-input>
          </div>

          <div class="form-group col-2">
            <label>Number of Days</label>
            <fg-input 
            type="text" 
            name="no_of_days" 
            v-validate="modelValidations.no_of_days"
            v-model="model.no_of_days"
            :error="getError('no_of_days')">
            <el-input-number v-model="model.no_of_days" :min="1"></el-input-number>
            </fg-input>
          </div>

          <div class="form-group col-2">
            <label for>GST Type</label>
            <el-select
              name="GST_type"
              class="select-default"
              placeholder="Select Type"
              v-model="model.GST_type"
              v-validate="modelValidations.GST_type"
              :error="getError('GST_type')">
              <el-option
                v-for="(option, index) in gstTypes"
                class="select-success"
                :value="option"
                :label="`${option}`"
                :key="index"
              ></el-option>
            </el-select>
          </div>

          <div class="form-group col-4">
            <label>GSTIN</label>
            <fg-input type="text" name="gstin" v-model="model.gstin" v-validate="modelValidations.gstin" :error="getError('gstin')"></fg-input>
          </div>

          <div class="form-group col-4">
            <label>Delivery Note</label>
            <fg-input type="text" name="delivery_note" v-model="model.delivery_note" v-validate="modelValidations.delivery_note" :error="getError('delivery_note')"></fg-input>
          </div>

          <div class="form-group col-2">
            <label>Shipping Charges</label>
            <fg-input type="number" name="shipping_charges" v-model="model.shipping_charges" v-validate="modelValidations.shipping_charges" :error="getError('shipping_charges')"></fg-input>
          </div>

          <div class="form-group col-2">
            <label>Consultation Charge</label>
            <fg-input type="number" name="consultation_charge" v-model="model.consultation_charge" v-validate="modelValidations.consultation_charge" :error="getError('consultation_charge')"></fg-input>
          </div>

          <div class="form-group col-4">
            <label>Is Estimate ?</label>
            <fg-input type="number" name="isEstimate" v-model="model.isEstimate.toString()" v-validate="modelValidations.isEstimate" :error="getError('isEstimate')">
              <p-switch v-model="model.isEstimate" on-text="Yes" off-text="No"></p-switch>
            </fg-input>
          </div>

          <!-- <div class="form-group col-4" v-if="false">
            <label for>Payment Mode</label>
            <fg-input 
            type="text" 
            name="mode" 
            v-validate="modelValidations.mode"
            v-model="model.mode"
            :error="getError('mode')">
                <el-select
                name="mode"
                class="select-default"
                placeholder="Select Type"
                v-model="model.mode"
                :class="!getError('mode') ? 'select-default' : 'select-danger'">
                <el-option
                    v-for="(option, index) in modes"
                    class="select-success"
                    :value="option.id"
                    :label="`${option.name}`"
                    :key="index"
                ></el-option>
                </el-select>
            </fg-input>
          </div>
          
          <div class="form-group col-4" v-if="false">
            <label>Payment ID</label>
            <fg-input type="text" name="payment_id" v-model="model.payment_id" v-validate="modelValidations.payment_id" :error="getError('payment_id')"></fg-input>
          </div> -->


        </div>
        <hr>

        <el-table
          style="width: 100%"
          :data="model.items"
          height="300"
          show-summary
          sum-text="Totals"
          :summary-method="getSummaries"
        >
          <el-table-column :min-width="min_width" type="index"></el-table-column>

          <el-table-column :min-width="250" label="Product" align="center">
            <div slot-scope="{row}" class="input-container">
             
                <el-select
                  name="comment"
                  class="select-default"
                  placeholder="Select Product"
                  v-model="row.product_id"
                  filterable
                  @change="updateProduct(row)"
                >
                  <el-option
                    v-for="(option, index) in products"
                    class="select-default"
                    :value="option.id"
                    :label="`${option.product_id} - ${option.name}`"
                    :key="index"
                  ></el-option>
                </el-select>

            </div>
          </el-table-column>

          <!-- <el-table-column :min-width="100" label="Prod ID" align="center" prop="product.product_id"></el-table-column> -->
          <!-- <el-table-column :min-width="150" label="Prod Name" align="left" prop="product_name"></el-table-column> -->
          <el-table-column :min-width="100" label="Type" align="left" prop="product.product_type.name"></el-table-column>
          <el-table-column :min-width="100" label="U.Qty" align="center" prop="product.quantity"></el-table-column>

          <!-- <el-table-column :min-width="100" label="Rate" align="center">
            <div slot-scope="{row}" class="td-number">{{ `Rs. ${Math.round(row.product.purchase_price)}` }}</div>
          </el-table-column> -->

          <el-table-column :min-width="150" label="Quantity" align="center">
            <div slot-scope="{row}" class="td-number">
              <!-- <fg-input type="text" name="quantity" v-model="row.quantity"></fg-input> -->
              <div class="btn-group">
                <p-button type="default" size="sm" @click.native="decreaseQuantity(row)" outline>
                  <i class="nc-icon nc-simple-delete"></i>
                </p-button>
                <p-button type="default" size="sm">{{ row.quantity }}</p-button>
                <p-button type="default" size="sm" @click.native="increaseQuantity(row)" outline>
                  <i class="nc-icon nc-simple-add"></i>
                </p-button>
              </div>
            </div>
          </el-table-column>

          <!-- <el-table-column :min-width="100" label="GST" align="center">
            <div slot-scope="{row}" class="td-number">{{ `Rs. ${Math.round(row.product.purchase_price * (row.product.gst_type.percentage/100))}` }}</div>
          </el-table-column> -->

          <el-table-column :min-width="100" label="Price" align="center">
            <div slot-scope="{row}" class="td-number">{{ `Rs. ${Math.round(row.product.sale_price)}` }}</div>
          </el-table-column>

          <el-table-column :min-width="100" label="GST %" align="center">
            <div slot-scope="{row}" class="td-number">{{ `${row.product.gst_type.percentage} %` }}</div>
          </el-table-column>

          <el-table-column :min-width="150" label="Discount" align="center">
            <div slot-scope="{row}" class="input-container">
              <el-select
                name="comment"
                class="select-default"
                placeholder="Select Discount"
                v-model="row.discount"
                filterable
                @change="computeAmount(row)"
                value-key="id"
              >
                <el-option
                  v-for="(option, index) in discounts"
                  class="select-default"
                  :value="option"
                  :label="`${option.name}`"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
          </el-table-column>

          <el-table-column :min-width="150" label="Disc. Amount" align="center">
            <div slot-scope="{row}" class="td-number">{{ `Rs. ${row.discount_amount}` }}</div>
          </el-table-column>

          <el-table-column :min-width="100" label="Amount" align="center">
            <div slot-scope="{row}" class="td-number">{{ `Rs. ${computeAmount(row)}` }}</div>
          </el-table-column>

          <el-table-column min-width="150" label>
            <div slot-scope="props" class="td-actions">
              <p-button type="danger" size="sm" simple icon outline round @click="removeProductItem(props.$index)">
                <i class="fa fa-trash"></i>
              </p-button>
              <p-button type="info" size="sm" simple icon outline round @click="addProductItem()">
                <i class="fa fa-plus"></i>
              </p-button>
            </div>
          </el-table-column>

        </el-table>
      </div>
      <div class="card-footer text-right">
        <p-button v-if="!model.isEstimate && model.due_amount > 0" type="success" @click.prevent="openPaymentModal" class="mr-2">Accept Payment</p-button>
        <p-button type="warning" @click.prevent="validate">Update Bill</p-button>
      </div>
    </form>

    <modal
      :show.sync="modals.payment"
      headerClasses="justify-content-center"
      footer-classes="justify-content-center"
      >
      <h5 slot="header" class="modal-title">Accept Payment</h5>

      <collapse>
        <collapse-item name="1">
          <template slot="title">
            <div>
              <div class="pull-left">Previous Payments</div>
              <div class="pull-right">{{ `Pending Rs. ${this.model.due_amount}` }}</div>
            </div>
          </template>
          <el-table :data="this.model.payments">
            <el-table-column min-width="10" prop="id" label="ID" v-if="false"></el-table-column>
            <el-table-column min-width="100" prop="mode_of_payment.name" label="Mode"></el-table-column>
            <el-table-column min-width="100" prop="transaction_id" label="Txn ID"></el-table-column>
            <el-table-column min-width="100" prop="amount" label="Amount" header-align="right" align="right"></el-table-column>
          </el-table>
        </collapse-item>
      </collapse>
      
      <hr v-if="this.model.due_amount > 0">
      <form data-vv-scope="add" v-if="modes && this.model.due_amount > 0">
        <div class="row">

          <div class="form-group col-12">
            <label for>Payment Mode</label>
              <el-select
                name="mode"
                class="select-default"
                placeholder="Select Mode"
                v-model="payment.mode_of_payment_id"
                filterable
              >
                <el-option
                  v-for="(option, index) in modes"
                  class="select-success"
                  :value="option.id"
                  :label="`${option.name}`"
                  :key="index"
                ></el-option>
              </el-select>
          </div>

          <div class="form-group col-6">
            <label>Transaction ID</label>
            <fg-input type="text" name="transaction_id" v-model="payment.transaction_id"></fg-input>
          </div>

          <div class="form-group col-6">
            <label>Payment Amount</label>
            <fg-input type="text" name="transaction_id" v-model="payment.amount"></fg-input>
          </div>

          <div class="form-group col-12">
            <label for>Date & Time</label>
            <fg-input
              name="datetime"
              v-model="payment.datetime"
            >
              <el-date-picker v-model="payment.datetime" type="datetime" placeholder="Select date and time"></el-date-picker>
            </fg-input>
          </div>

        </div>
      </form>
      <template slot="footer">
        <p-button type="success" @click="acceptPayment">Save Payment</p-button>
        <!-- <p-button type="danger" @click.native="modals.addStock = false">Close</p-button> -->
      </template>
    </modal>

  </div>
</template>
<script>
import {
  Upload,
  DatePicker,
  Select,
  Option,
  Table,
  TableColumn,
  InputNumber
} from "element-ui";
import { mapGetters } from "vuex";
import { Modal, Switch, Collapse, CollapseItem } from "src/components/UIComponents";
import swal from 'sweetalert2'

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Upload.name]: Upload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [InputNumber.name]: InputNumber,
    [Switch.name]: Switch,
    Modal,
    Collapse,
    CollapseItem
  },
  mounted() {
    this.$store.dispatch("fetchBilling",this.$route.params.bill_id);
    this.$store.dispatch("fetchDiscountsAll");
    this.$store.dispatch("fetchModesAll");
    this.$store.dispatch("fetchProductsAll");
    this.$nextTick(() => {
      this.min_width = 50;
    })
  },
  computed: {
    ...mapGetters({
      currentUser: "getCurrentUser",
      model: "getBilling",
      discounts: "getDiscounts",
      modes: "getModes",
      products: "getProducts",
    }),
    total() {
      const values = this.model.items.map(item =>
        parseInt(item.product.sale_price) * item.quantity
      );
      return values.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          return prev + curr;
        } else {
          return prev;
        }
      }, 0);
    },
    discount() {
      const values = this.model.items.map(item => {
        let discount = item.discount;
        let value = 0;
        switch (discount.type) {
          case "reduction":
            value = Math.floor(item.quantity * parseInt(discount.value));
            break;
          case "percent":
            value = Math.floor(item.quantity * item.product.sale_price * (parseInt(discount.value) / 100));
            break;
          default:
            value = 0;
        }
        return value;
      });
      return values.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          return prev + curr;
        } else {
          return prev;
        }
      }, 0);
    },
    amount() {
      const values = this.model.items.map(item => item.amount);
      return values.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          return prev + curr;
        } else {
          return prev;
        }
      }, 0);
    },
    gst_amount() {
      const values = this.model.items.map(item => {

          return Math.ceil(item.amount / (100 + item.product.gst_type.percentage) * item.product.gst_type.percentage);

          // let discount = this.discounts.find(
          //   discount => discount.id == item.discount
          // );
          // let value = 0;
          // switch (discount.type) {
          //   case "reduction":
          //     value = parseInt(discount.value);
          //     break;
          //   case "percent":
          //     value = Math.floor(
          //       item.product.sale_price * (parseInt(discount.value) / 100)
          //     );
          //     break;
          //   default:
          //     value = 0;
          // }
          // let discounted_price = parseInt(item.product.sale_price) - value
          // return Math.ceil(discounted_price * (item.product.gst_type.percentage/100)) * item.quantity
        });
      return values.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          return prev + curr;
        } else {
          return prev;
        }
      }, 0);
    }
  },
  data() {
    return {
      current_patient: null,
      modelValidations: {
        patient_id: {
          required: true
        },
        location_id: {
          required: true
        },
        ref_name: {
          required: false
        },
        ref_number: {
          required: false
        },
        diagnosis: {
          required: true
        },
        note: {
          required: false
        },
        date: {
          required: true
        },
        no_of_days: {
          required: true
        },
        start_date: {
          required: true
        },
        GST_type: {
          required: true
        },
        delivery_note: {
          required: true
        },
        // mode: {
        //   required: true
        // },
        // payment_id: {
        //   required: true
        // }
        isEstimate: {
          required: true
        },
        shipping_charges: {
          required: true
        },
        consultation_charge: {
          required: true
        },
        gstin: {
          required: false
        }
        
      },
      payment: {
        amount: 0,
        mode_of_payment_id: null,
        transaction_id: null,
        datetime: null
      },
      gstTypes: [
        "CSGST",
        "IGST"
      ],
      min_width: 49,
      modals: {
        payment: false
      }
    };
  },
  methods: {
    updatePatient() {
      this.model.patient = this.patients[
        this.patients.findIndex(element => {
          return element.id == this.model.patient_id;
        })
      ];
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        this.$emit("on-submit", this.registerForm, isValid);
        if (isValid) {
          this.model.employee_id = this.currentUser.profile_id;
          this.model.total = this.total;
          this.model.amount = this.amount;
          this.model.discount = this.discount;
          this.model.GST_amount = this.gst_amount;
          // this.model.items = this.items
          this.$store.dispatch('updateBillingNew', this.model)
        }
      });
    },
    increaseQuantity(row) {
      row.quantity++;
      this.computeAmount(row);
    },
    decreaseQuantity(row) {
      if (row.quantity > 0) {
        row.quantity--;
        this.computeAmount(row);
      }
    },
    updateProduct(row){
      row.product = this.products.find(
        product => product.id == row.product_id
      );
      this.computeAmount(row)
    },
    computeAmount(row) {
      let discount = row.discount;
      let discount_amount = 0
      if(discount){
        switch (discount.type) {
          case "reduction":
            discount_amount = parseInt(discount.value)
            // row.amount = row.quantity * row.product.sale_price - parseInt(discount.value);
            break;
          case "percent":
            discount_amount = Math.round(row.product.sale_price * (parseInt(discount.value) / 100))
            // row.amount = Math.ceil(row.quantity * row.product.sale_price - row.quantity * row.product.sale_price * (parseInt(discount.value) / 100));
            break;
          default:
            row.amount = row.quantity * row.product.sale_price;
        }
        row.amount = Math.ceil(row.quantity * (row.product.sale_price - discount_amount));
        row.discount_amount = Math.ceil(row.quantity * discount_amount)
      }
      else{
        row.amount = 0
        row.discount_amount = 0
      }
      
      return row.amount;
    },
    addProductItem(){
        let item = {
            product: {
                id: null,
                sale_price: 0,
                quantity: 0,
                product_type:{
                    name: '-'
                },
                gst_type: {
                    percentage: 0
                }
            },
            quantity: 1,
            discount: 1,
            amount: 0,
            discount_amount: 0
        }
        item.discount = this.discounts[0]
        this.model.items.push(item)
    },
    removeProductItem(index) {
      this.model.items.splice(index, 1)
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "=";
          return;
        }

        // if (index === 4) {
        //   const values = data.map(item => Math.round((item.product.purchase_price) * item.quantity));
        //   sums[index] = values.reduce((prev, curr) => {
        //     const value = Number(curr);
        //     if (!isNaN(value)) {
        //       return prev + curr;
        //     } else {
        //       return prev;
        //     }
        //   }, 0);
        // }
        
        
        // if (index === 9) {
        //   const values = data.map(item => Math.ceil(item.product.sale_price * (item.product.gst_type.percentage/100)) * item.quantity);
        //   sums[index] = values.reduce((prev, curr) => {
        //     const value = Number(curr);
        //     if (!isNaN(value)) {
        //       return prev + curr;
        //     } else {
        //       return prev;
        //     }
        //   }, 0);
        // }
        
        
        if (index === 5) {
          const values = data.map(item => parseInt(item.product.sale_price) * item.quantity);
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }

        if (index === 8) {
          const values = data.map(item => item.discount_amount);
          // console.log(values)
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }

        if (index === 9) {
          const values = data.map(item => item.amount);
          // console.log(values)
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });

      // sums[5] = 'Rs. ' + Math.abs(sums[7] - sums[4]);
      // sums[4] = "Rs. " + sums[4];
      // sums[10] = "Rs. " + sums[10];
      sums[5] = "Rs. " + sums[5];
      sums[8] = "Rs. " + sums[8];
      sums[9] = "Rs. " + sums[9];
      return sums;
    },
    openPaymentModal(){
      this.payment.mode_of_payment_id = null
      if(this.model.due_amount)
        this.payment.amount = this.model.due_amount
      else
        this.payment.amount = 0 
      this.payment.transaction_id = ''
      this.payment.datetime = new Date()

      this.modals.payment = true
    },
    acceptPayment(){
      if(this.payment.mode_of_payment_id && this.payment.amount && this.payment.transaction_id && this.payment.datetime){
        this.payment.model_id = this.model.id
        this.$store.dispatch('createPayment', this.payment)
        this.modals.payment = false
      }
      else{
        alert('all feilds are required!')
      }
    },
  },
  watch: {
    model: {
      handler: function(val) {
        val.items.forEach(row => this.computeAmount(row))
      },
      immediate: true
    }
  }
};
</script>
<style>
  .el-input-number .el-input__inner{
    outline: none;
  }

  .btn-primary, .form-group .el-input-number .plus-button, .form-group .el-input-number .el-input-number__decrease, .form-group .el-input-number .el-input-number__increase{
    background-color: #66615B;
    color: #fff;
  }

  .form-group .el-input-number .el-input-number__increase{
    border-radius: 0 5px 5px 0 !important;
  }

  .form-group .el-input-number .el-input-number__decrease{
    border-radius: 5px 0px 0px 5px !important;
  }

  .select-default.el-select .el-input input{
    border-radius: 5px;
  }
</style>
